export default __webpack_public_path__ + "static/media/LOGO.ec0a020e.png";